import lozad from 'lozad';
import bus from '../util/eventBus';

const lazy = () => {
  const lazyEl = document.querySelector('.u-lazy');

  if (lazyEl) {
    const observer = lozad('.u-lazy', {
      rootMargin: '10px 0px',
      threshold: 0.1,
    });
    const observe = () => observer.observe();
    observe();

    bus.on('feag-slide-change', () => observe());

    bus.on('feag-load-more-finish', () => observe());

    document.addEventListener('facetwp-loaded', () => observe());
    document.addEventListener('facetwp-refresh', () => observe());

    document.addEventListener('DOMContentLoaded', () => observe, {
      once: true,
    });
  }
};

lazy();
